import { render } from "./ExpandableCell.vue?vue&type=template&id=24ecce65&scoped=true&ts=true"
import script from "./ExpandableCell.vue?vue&type=script&lang=ts"
export * from "./ExpandableCell.vue?vue&type=script&lang=ts"

import "./ExpandableCell.vue?vue&type=style&index=0&id=24ecce65&lang=scss&scoped=true"

import exportComponent from "/builds/boikovky/pro2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ecce65"]])

export default __exports__